import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

/**
 * Deutsche Zahleneingabe ("1.234,56") in eine Zahl uebersetzen.
 * Ein bereits englisch geschriebenes "1234.56" bleibt unangetastet.
 * Liegt hier statt bei den Buchhaltungs-Utils, weil auch die Dokumentenablage
 * ueber das geteilte InlineField darauf zugreift.
 *
 * "1.190" ohne Komma ist im Deutschen 1190, nicht 1,19 — Punkte in Dreiergruppen
 * gelten deshalb als Tausendertrenner (bis 21.10.2026 wurde daraus still 1,19 €).
 * "0.500" und "12.50" bleiben Dezimalzahlen. Reste wie "12abc" ergeben null statt
 * still 12 (parseFloat liest nur den Anfang).
 */
export function parseGermanNumber(raw: unknown): number | null {
  if (raw == null || raw === '') return null
  if (typeof raw === 'number') return Number.isFinite(raw) ? raw : null
  const s = String(raw).trim().replace(/[\s€]/g, '')
  if (!s) return null
  let normalized = s
  if (s.includes(',')) normalized = s.replace(/\./g, '').replace(',', '.')
  else if (/^-?[1-9]\d{0,2}(\.\d{3})+$/.test(s)) normalized = s.replace(/\./g, '')
  if (!/^-?\d+(\.\d+)?$/.test(normalized)) return null
  const n = parseFloat(normalized)
  return Number.isFinite(n) ? n : null
}
